(() => {
  'use strict';
  const props = value => Array.isArray(value) ? Object.fromEntries(value) : (value || {});
  const decoded = value => {
    let text=String(value);
    for(let pass=0;pass<4;pass++){
      const next=text.replace(/&(?:quot|apos|lt|gt|amp|#39|#34|#x27|#x22);/gi,entity=>({'&quot;':'"','&apos;':"'",'&lt;':'<','&gt;':'>','&amp;':'&','&#39;':"'",'&#34;':'"','&#x27;':"'",'&#x22;':'"'}[entity.toLowerCase()]));
      if(next===text)break;text=next;
    }
    return text;
  };
  const stable = value => JSON.stringify(Object.keys(value || {}).sort().map(key => [key,decoded(value[key])]));
  const fingerprint = lines => JSON.stringify(lines.map(line => [String(line.variant_id || line.id),line.quantity,stable(props(line.properties)),line.selling_plan_allocation?.selling_plan?.id || line.plan || null]).sort((a,b)=>JSON.stringify(a).localeCompare(JSON.stringify(b))));
  const root = () => window.Shopify?.routes?.root || '/';
  const messages = () => document.getElementById('gc-choice-dialog')?.dataset || {};
  const api = window.GlassifyCartUpgrade = {saving:false};
  const belonging = (cart,id) => cart.items.filter(line => String(props(line.properties)._bundle_instance_id) === id);
  async function request(path,body) {
    const response = await fetch(root()+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},...(body?{body:JSON.stringify(body)}:{})});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description==='string'?data.description:messages().error);
    return data;
  }
  function subscriptionDiscount(items) {
    let remaining=20,total=0;
    items.filter(line=>line.eligible&&!line.plan).sort((a,b)=>a.price-b.price).forEach(line=>{
      const quantity=Math.min(remaining,line.quantity);
      if(quantity>0){total+=Math.round(line.price*quantity*.33);remaining-=quantity;}
    });
    return total;
  }
  api.quote = (pricing,sourceKey,target) => {
    const source=pricing.items.find(line=>line.key===sourceKey);
    if(!source) return null;
    const subscribed=pricing.items.some(line=>props(line.properties)._subscription_product_type);
    const beforeDiscount=subscribed?subscriptionDiscount(pricing.items):0;
    if(pricing.discount!==beforeDiscount) return null;
    const next=pricing.items.map(line=>line===source?{...line,price:target.price,eligible:target.eligible}:line);
    const afterDiscount=subscribed?subscriptionDiscount(next):0;
    return {amount:(target.price-source.price)*source.quantity+beforeDiscount-afterDiscount,subscribed};
  };
  api.commit = async ({pricing,bundleId,sourceKey,target,group,inputId}) => {
    if(api.saving) throw new Error(messages().updating);
    api.saving=true;
    const revision=Date.now().toString(36)+Math.random().toString(36).slice(2,9);
    try {
      const before=await request('cart.js');
      const original=belonging(before,bundleId);
      const expected=belonging(pricing,bundleId);
      if(!original.length||fingerprint(original)!==fingerprint(expected)||before.total_price!==pricing.total) throw new Error(messages().stale);
      const expectedSource=expected.find(line=>line.key===sourceKey);
      const source=original.find(line=>expectedSource&&String(line.variant_id)===String(expectedSource.id)&&stable(line.properties)===stable(props(expectedSource.properties)));
      const main=original.find(line=>String(line.properties?._is_main_product)==='true');
      if(!source||!main||source===main) throw new Error(messages().stale);
      const liveProduct=await request('products/'+encodeURIComponent(target.handle)+'.js');
      const liveTarget=liveProduct.variants.find(variant=>String(variant.id)===String(target.id));
      if(!liveTarget?.available) throw new Error(messages().unavailable);
      if(liveTarget.price!==target.price) throw new Error(messages().stale);
      const productResponse=await fetch(root()+'products/'+encodeURIComponent(main.handle)+'?variant='+main.variant_id,{credentials:'same-origin'});
      if(!productResponse.ok) throw new Error(messages().error);
      const page=new DOMParser().parseFromString(await productResponse.text(),'text/html');
      const input=[...page.querySelectorAll('input[data-extra-variant-id]')].find(el=>el.name===group&&el.getAttribute('variant-id')===String(target.id));
      if(!input||input.disabled) throw new Error(messages().unavailable);
      inputId=input.id;
      const items=original.map(line=>{
        const properties={...props(line.properties),_edit_revision:revision};
        if(line===main){
          let configuration=[];
          try {configuration=JSON.parse(decoded(properties._glassify_configuration||'[]'));}catch(_){}
          properties._glassify_configuration=JSON.stringify([...configuration.filter(entry=>entry.name!==group),{name:group,id:inputId}]);
          if(group==='glass-coating') properties._upgrade_coating='false';
          if(Number.isFinite(Number(properties._product_total_price))) properties._product_total_price=Number(properties._product_total_price)+(target.price-source.original_price);
          const oldReference=pricing.items.find(item=>item.key===sourceKey)?.compare || source.original_price;
          if(Number.isFinite(Number(properties._product_total_compare_at_price))) properties._product_total_compare_at_price=Number(properties._product_total_compare_at_price)+Math.max(target.price,target.compare)-Math.max(source.original_price,oldReference);
        }
        return {id:line===source?target.id:line.variant_id,quantity:line.quantity,properties,...(line.selling_plan_allocation?{selling_plan:line.selling_plan_allocation.selling_plan.id}:{})};
      });
      try {
        await request('cart/add.js',{items});
        const afterAdd=await request('cart.js');
        const oldLines=belonging(afterAdd,bundleId).filter(line=>line.properties._edit_revision!==revision);
        const newLines=belonging(afterAdd,bundleId).filter(line=>line.properties._edit_revision===revision);
        if(fingerprint(oldLines)!==fingerprint(original)||newLines.length!==items.length) throw new Error(messages().stale);
        await request('cart/update.js',{updates:Object.fromEntries(oldLines.map(line=>[line.key,0]))});
      } catch(error) {
        const recovery=await request('cart.js');
        const oldLines=belonging(recovery,bundleId).filter(line=>line.properties._edit_revision!==revision);
        const newLines=belonging(recovery,bundleId).filter(line=>line.properties._edit_revision===revision);
        if(oldLines.length!==0||newLines.length!==items.length){
          if(newLines.length) await request('cart/update.js',{updates:Object.fromEntries(newLines.map(line=>[line.key,0]))});
          throw error;
        }
      }
      const verified=await request('cart.js');
      const result=belonging(verified,bundleId);
      if(result.length!==items.length||result.some(line=>line.properties._edit_revision!==revision)) throw new Error(messages().stale);
      return {cart:verified,inputId};
    } finally {api.saving=false;}
  };
  function getPricing(){const el=document.querySelector('#AjaxCartForm [data-gc-pricing]');return el?JSON.parse(el.textContent):null;}
  function targetFrom(content){const d=content.dataset;return{id:Number(d.targetId),handle:d.targetHandle,price:Number(d.targetPrice),compare:Number(d.targetCompare),eligible:d.targetEligible==='true'};}
  function money(cents,currency){return new Intl.NumberFormat(document.documentElement.lang||'da-DK',{style:'currency',currency:currency||'DKK',minimumFractionDigits:cents%100?2:0,maximumFractionDigits:2}).format(cents/100);}
  let opener,active,context,applying=false;
  function refreshPrices(){
    const pricing=getPricing();if(!pricing)return;
    document.querySelectorAll('[data-gc-quick-price]').forEach(label=>{
      const template=document.getElementById('gc-choice-'+label.dataset.gcQuickPrice);
      const content=template?.content.querySelector('.gc-choice-content');
      if(!content)return;
      const quote=api.quote(pricing,content.dataset.sourceKey,targetFrom(content));
      label.textContent=quote&&quote.amount>=0?'+ '+money(quote.amount,pricing.currency):'';
      label.hidden=!label.textContent;
    });
  }
  function close(){if(api.saving)return;const dialog=document.getElementById('gc-choice-dialog');dialog?.close();if(opener?.isConnected)opener.focus({preventScroll:true});}
  function open(trigger){
    const template=document.getElementById('gc-choice-'+trigger.dataset.gcOpenChoice);
    const dialog=document.getElementById('gc-choice-dialog');
    if(!template||!dialog||applying)return;
    opener=trigger;
    const host=dialog.querySelector('.gc-choice-dialog-body');host.replaceChildren(template.content.cloneNode(true));
    active=host.querySelector('.gc-choice-content');
    const pricing=getPricing();
    context={pricing,bundleId:active.dataset.bundle,sourceKey:active.dataset.sourceKey,target:targetFrom(active),group:active.dataset.group};
    const quote=context.target.id?api.quote(pricing,context.sourceKey,context.target):null;
    const bundle=[...document.querySelectorAll('.gc-bundle')].find(el=>el.dataset.bundleId===context.bundleId);
    const edit=bundle?.querySelector('.gc-edit');
    const editLink=active.querySelector('.gc-choice-edit');if(editLink&&edit)editLink.href=edit.href;
    if(quote&&quote.amount>=0){
      active.querySelectorAll('[data-gc-upgrade-price]').forEach(el=>el.textContent='+ '+money(quote.amount,pricing.currency));
      active.querySelector('[data-gc-sub-note]').hidden=!quote.subscribed;
    }else{
      const apply=active.querySelector('.gc-choice-apply');if(apply)apply.hidden=true;
      if(editLink)editLink.hidden=false;
    }
    dialog.showModal();dialog.scrollTop=0;dialog.querySelector('.gc-choice-close').focus({preventScroll:true});
  }
  function reveal(id){
    const sidebar=document.getElementById('site-cart-sidebar');
    const bundles=[...(sidebar?.querySelectorAll('.gc-bundle')||[])];
    const chosen=bundles.find(el=>el.dataset.bundleId===id);
    bundles.forEach(el=>{el.classList.toggle('active',el===chosen);el.querySelector('.cart-bundle-title')?.setAttribute('aria-expanded',String(el===chosen));});
    if(!chosen)return;
    requestAnimationFrame(()=>{const body=sidebar.querySelector('.sidebar__body');body?.scrollTo({top:body.scrollTop+chosen.getBoundingClientRect().top-body.getBoundingClientRect().top-12,behavior:'instant'});chosen.querySelector('.cart-bundle-title')?.focus({preventScroll:true});});
  }
  async function apply(button){
    if(api.saving||applying)return;
    applying=true;
    const selection=context;
    button.disabled=true;const previous=button.textContent;button.textContent=messages().updating;
    const status=active.querySelector('.gc-choice-status');status.hidden=true;
    let saved=false;
    try{
      const result=await api.commit(selection);
      saved=true;
      // Close as soon as Shopify confirms the upgrade, before redrawing the drawer.
      close();
      const editor=window.GlassifyCartEdit;
      if(editor?.requested&&new URLSearchParams(location.search).get('cart_edit')===selection.bundleId){
        editor.original=belonging(result.cart,selection.bundleId);editor.main=editor.original.find(line=>String(line.properties._is_main_product)==='true');
        const radio=document.getElementById(result.inputId);if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
      }
      await document.getElementById('AjaxCartForm').renderCartDrawer();
      document.getElementById('site-cart-sidebar')?.show();
      reveal(selection.bundleId);refreshPrices();
    }catch(error){
      if(saved){
        // The purchase choice is already saved. Reload its cart view, never submit it twice.
        const url=new URL(location.href);url.searchParams.set('cart_open','1');url.searchParams.set('cart_upgrade',selection.bundleId);
        location.assign(url.toString());
      }else{
        status.textContent=error.message||messages().error;status.hidden=false;
        await document.getElementById('AjaxCartForm')?.renderCartDrawer().catch(()=>{});
      }
    }finally{applying=false;button.disabled=false;button.textContent=previous;}
  }
  function init(){
    document.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-gc-open-choice]');
      if(trigger){event.preventDefault();open(trigger);return;}
      if(event.target.closest('[data-gc-choice-close]')){event.preventDefault();close();return;}
      const button=event.target.closest('.gc-choice-apply');if(button){event.preventDefault();apply(button);}
    });
    const dialog=document.getElementById('gc-choice-dialog');
    dialog?.addEventListener('cancel',event=>{event.preventDefault();close();});
    document.addEventListener('keydown',event=>{if(dialog?.open&&event.key==='Escape'){event.preventDefault();event.stopImmediatePropagation();close();}},true);
    dialog?.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close();}});
    refreshPrices();
    const upgraded=new URLSearchParams(location.search).get('cart_upgrade');
    if(upgraded){document.getElementById('site-cart-sidebar')?.show();reveal(upgraded);const url=new URL(location.href);url.searchParams.delete('cart_upgrade');history.replaceState(history.state,'',url);}
    const sidebar=document.getElementById('site-cart-sidebar');
    if(sidebar)new MutationObserver(mutations=>{if(mutations.some(m=>[...m.addedNodes].some(node=>node.nodeType===1)))refreshPrices();}).observe(sidebar,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
